import ProductGrid from "@/components/ProductGrid";

export default function BodyButter() {
  return (
    <ProductGrid
      category="body-butter"
      eyebrow="Body Butter Collection"
      title="Whipped. Soft. Devotional."
      blurb="Small-batch shea + coconut body butter, whipped to order in your chosen scent. Melts into skin — never greasy, never rushed."
    />
  );
}
